import * as actionType from './ActionType';

export const loginAction = (userIn, menuItemsIn) => ({
  type: actionType.LOGIN,
  user: userIn,
  menuItems: menuItemsIn
});
export const logoutAction = (menuItemsIn) => ({
  type: actionType.LOGOUT,
  menuItems: menuItemsIn
});
export const scrollTo = (scrollToIn) => ({
  type: actionType.CHANGE,
  scrollTo: scrollToIn
});
export const loader = (isLoadingIn) => ({
  type: actionType.LOADING,
  isLoading: isLoadingIn
});
export const setMenuPosition = (menuPositionIn) => ({
  type: actionType.SETMENUNPOSITION,
  menuPosition: menuPositionIn
});
export const addToCart = (product) => ({
  type: actionType.ADDTOCART,
  product: product
});
export const updateCart = (products) => ({
  type: actionType.UPDATECART,
  products: products
});
export const categoryFetch = (categories) => ({
  type: actionType.CATEGORYFETCH,
  categories: categories
});
export const selectedCat = (category) => ({
  type: actionType.CATEGORYCHANGE,
  categories: category
});
/*
export const userLoginAction = (userIn) => ({
  type: actionType.ADDLOGGEDUSER,
  user: userIn
});
export const userLogoutAction = () => ({
  type: actionType.REMOVELOGGEDUSER
});
*/



// WEBPACK FOOTER //
// ./src/actions/index.js